<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_cu1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('abnormalTran_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('abnormalTran_setMultipleRead_button')"
          @click="setMultipleRead"
        >
          批量标记已读
        </el-button>
        <el-button
          v-if="getLimit('abnormalTran_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      highlight-hover-row
      :loading="loading"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="description"
          title="说明"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.description"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isRead"
          :formatter="formatterStatus"
          title="状态"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isRead" clearable placeholder="请选择">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="address"
          title="地址"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.address"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="happenTime"
          title="发生时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.happenTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'happenTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="更新时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="140" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('abnormalTran_detail_button')"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <template>
            <el-tooltip
              v-if="
                getLimit('abnormalTran_setSingleRead_button') &&
                  scope.row.isRead === 0
              "
              effect="dark"
              content="标记已读"
              placement="top"
            >
              <vxe-button type="text" @click="setSingleRead(scope.row.code)">
                <i class="el-icon-folder" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-else-if="
                getLimit('abnormalTran_read_button') && scope.row.isRead != 0
              "
              effect="dark"
              content="已读"
              placement="top"
            >
              <vxe-button type="text">
                <i class="el-icon-folder-opened" />
              </vxe-button>
            </el-tooltip>
          </template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="600"
      height="600"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compDetail from "./components/transportAbnormalDetail.vue";
import { getTransportAbnormalList, batchRead } from "@/api/CustomerService";
export default {
  name: "TransportAbnormal",
  components: {
    compDetail
  },
  data() {
    return {
      exportObj: {
        exportUrl:
          "/ntocc-basic-api/transportAbnormal/exportTransportAbnormalList", //导出接口
        name: "运输异常"
      },
      loading: false,
      tableData: [],
      modelDetailFlag: false,
      listQuery: {
        happenTimeRange: "",
        gmtCreatedRange: "",
        gmtModifiedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 状态
      statusList: [{ label: "未读", value: 0 }, { label: "已读", value: 1 }],
      //机构信息
      branchList: this.$store.state.components.branchList
    };
  },
  watch: {
    $route(to, from) {
      const v = to.query.todo;
      if (v) {
        this.listQuery.isRead = 0;
      } else {
        this.listQuery.isRead = "";
      }
      this.findList();
    }
  },
  created() {
    const v = this.$route.query.todo;
    if (v) {
      this.listQuery.isRead = 0;
    }
    this.findList();
  },
  methods: {
    async RefreshList() {
      this.$refs.xTable.clearSort();
      this.listQuery = {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      };
      await this.findList();
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getTransportAbnormalList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 标记单项已读
    setSingleRead(codes) {
      this.$confirm("确认标记已读吗？").then(_ => {
        batchRead({ codes }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 标记多项已读
    setMultipleRead() {
      const checkedRowArray = this.$refs.xTable.getSelectRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message({ message: "请选择需要设置的项目", type: "warning" });
        return false;
      }
      const isReadArray = checkedRowArray.filter(item => item.isRead === 1);
      if (isReadArray.length) {
        this.$message({ message: "已读消息请勿重复标记", type: "warning" });
        return false;
      }
      if (checkedRowArray.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
        return false;
      }
      this.$refs.xTable.clearCheckboxRow();
      const codes = checkedRowArray.map(item => item.code).join(",");
      batchRead({ codes }).then(response => {
        this.$message({ message: response.msg, type: "success" });
        this.findList();
      });
    },
    // 状态
    formatterStatus({ cellValue }) {
      const item = this.statusList.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 详情
    funcDetail(row) {
      this.$refs.detailRef.getInfo(row);
      this.modelDetailFlag = true;
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
